import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { environment as env } from '../../../../../src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
    AutoCompleteRequestSourcesEnum,
    AutoCompleteThemeEnum
} from '@draeger-academy/common/lib/services/acs-input/enums/auto-complete.enums';
import { AutoCompleteConfigInterface } from '@draeger-academy/common/lib/services/acs-input/interfaces/auto-complete.interfaces';
export interface IDWHeaderLinks {
    Label: string;
    Link: string;
}

@Component({
    selector: 'da-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
    public headerLinks: IDWHeaderLinks[];
    public site: string;
    public showMobileSearch = false;
    public requestUrl: string;
    public useAutocompleteV3: boolean;
    public logo = '';
    public title = '';
    private _$showMobileSearch: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showSearch: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showLogout: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$partnerPortalLink: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private _$isPortal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$showLinksInHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private _$showCart: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public configSearch: AutoCompleteConfigInterface = {
        context: AutoCompleteRequestSourcesEnum.SP,
        theme: AutoCompleteThemeEnum.HEADER,
        minCharsTypeAhead: 3,
        debounceTime: 200,
        displayMaxResults: 5,
        maxRequestResults: 200,
        goToTarget: true,
        showAllResultsLink: true,
        targetUrl: ''
    };

    constructor(
        protected _ref: ChangeDetectorRef,
        private _configurationService: ConfigurationService,
        private authenticationService: AuthenticationService,
        private _translateService: TranslateService
    ) {
        // this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        //     this._$showLinksInHeader.next(!this._configurationService.isSelectionPage());
        // });
    }

    public get showLogin$(): Observable<boolean> {
        return this._$showLogin.asObservable();
    }

    public get showLogout$(): Observable<boolean> {
        return this._$showLogout.asObservable();
    }

    public get partnerPortalLink$(): Observable<string> {
        return this._$partnerPortalLink.asObservable();
    }

    public get showLinksInHeader$(): Observable<boolean> {
        return this._$showLinksInHeader.asObservable();
    }

    public get isPortal$(): Observable<boolean> {
        return this._$isPortal.asObservable();
    }

    public get showCart$(): Observable<boolean> {
        return this._$showCart.asObservable();
    }

    public get showSearch$(): Observable<boolean> {
        return this._$showSearch.asObservable();
    }

    public get showMobileSearch$(): Observable<boolean> {
        return this._$showMobileSearch.asObservable();
    }
    ngOnInit() {
        const _isPortal = this._configurationService.isPartnerPage();
        this._configurationService.portalVersion$.subscribe((portalVersion) => {
            this._$showCart.next(portalVersion === 'v2');
            this._checkIfLoginShouldBeShown(_isPortal, portalVersion);
        });
        this._$showLinksInHeader.next(!_isPortal && !this._configurationService.isSelectionPage());

        this._$isPortal.next(_isPortal);
        this._configurationService.currentPortal$
            .pipe(
                filter((user) => user !== null),
                distinctUntilChanged()
            )
            .subscribe((portal) => {
                if (portal) {
                    this._$partnerPortalLink.next('/partner/' + portal);
                    this._$showLinksInHeader.next(false);
                }
            });
        this._setHeaderLabels();

        this.logo = env.locales + 'assets/images/logo.svg';

        if (this._configurationService.hasFeature('ShoppingCart')) this._$showCart.next(true);
        if (this._configurationService.hasFeature('SearchPage')) this._$showSearch.next(true);

        this._translateService.stream('common').subscribe((translation) => {
            this.configSearch.targetUrl = translation.targetUrl;
        });
    }

    private _setHeaderLabels() {
        this.headerLinks = [
            {
                Label: 'Contact Us',
                Link: '/en_uk/Contact'
            },
            {
                Label: 'Career',
                Link: '/en_career/Home'
            },
            {
                Label: 'CountrySelection',
                Link: '/CountrySelection'
            }
        ];
    }

    private _checkIfLoginShouldBeShown(isPortal = false, portalVersion: string): void {
        const _shouldHaveLogin = (!isPortal && this._configurationService.hasFeature('Login')) || (portalVersion === 'v2' && isPortal);
        this.authenticationService.loggedIn().subscribe((data) => {
            this._$showLogin.next(!data && _shouldHaveLogin);
            this._$showLogout.next(data && _shouldHaveLogin);
        });
    }

    public valuechange(valueTyped) {
        const isPortal = this._configurationService.isPartnerPage();

        let _site = isPortal ? this._configurationService.portalId : this._configurationService.getSiteFromUrl().site;
    }

    public toggleSearch() {
        this.showMobileSearch = !this.showMobileSearch;
    }
}
